var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionAltitudeMax16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6.665 2.472 3.308 9.451c.009.025.016.051.02.077H14a1 1 0 1 1 0 2H2a1 1 0 1 1 0-2h.007a.478.478 0 0 1 .02-.077l3.308-9.451a.705.705 0 0 1 1.33 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2c.254 0 .496.11.662.302l2.16 2.493A.729.729 0 0 1 14.272 6H13v2a1 1 0 1 1-2 0V6H9.728a.728.728 0 0 1-.55-1.205l2.16-2.493A.876.876 0 0 1 12 2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionAltitudeMax16);
export default __webpack_public_path__ + "static/media/ic_action_altitude_max_16.228dcc1ec4d91ad088e387af904bee96.svg";
export { ForwardRef as ReactComponent };